import { Box, Typography, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { BatchNotSelected } from './components/BatchNotSelected';
import { IRRScoreCards } from './components/IRRScoreComponents/IRRScoreCards';
import { IRRScoreDataTable } from './components/IRRScoreComponents/IRRScoreDataTable';
import { MetricProjectsDropdown } from './components/MetricProjectsDropdown';
import { ProjectNotSelected } from './components/ProjectNotSelected';
import { useMetricIRRScore } from './useMetricIRRScore';
import Dropdown from '../../wrapper-components/Dropdown/Dropdown';

export const MetricIRRScore = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const {
    irrScoreDateRange,
    isIRRScoreDateRangeLoading,
    date,
    handleChangeDate,
    shouldDisableDate,
    batchTypeOptions,
    batchTypeId,
    isMetricsBatchTypeListLoading,
    handleBatchTypeChange,
    projectId,
    filterTypeOptions,
    filterTypeId,
    handleFilterTypeChange,
    isFilterTypeListLoading,
  } = useMetricIRRScore();

  return (
    <Box
      sx={{ p: theme.spacing(6), display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
    >
      <Box sx={{ mb: theme.spacing(12) }}>
        <Typography variant="h4">{formatMessage({ id: 'metrics.irrScore.title' })}</Typography>
      </Box>
      <MetricProjectsDropdown />
      <Box
        id="metrics-irr-score-content"
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
      >
        <Box sx={{ display: 'flex', gap: theme.spacing(6) }}>
          <Dropdown
            id="metric-irr-score-filter-type-dropdown"
            options={filterTypeOptions}
            onChange={handleFilterTypeChange}
            label={formatMessage({ id: 'metrics.irrScore.typeFilter.label' })}
            placeholder={formatMessage({
              id: 'metrics.irrScore.typeFilter.label',
            })}
            disabled={isFilterTypeListLoading || filterTypeOptions.length === 0 || !projectId}
            width="medium"
            value={filterTypeId ?? ''}
          />
          <DatePicker
            label={formatMessage({ id: 'metrics.irrScore.datepicker.label' })}
            value={date}
            onChange={(newValue) => handleChangeDate(newValue)}
            minDate={dayjs(irrScoreDateRange?.minDate)}
            maxDate={dayjs(irrScoreDateRange?.maxDate)}
            shouldDisableDate={shouldDisableDate}
            disabled={isIRRScoreDateRangeLoading || !projectId || !batchTypeId}
            slotProps={{
              textField: {
                sx: {
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                },
              },
            }}
          />
          <Dropdown
            id="metric-irr-score-batch-type-dropdown"
            options={batchTypeOptions}
            onChange={handleBatchTypeChange}
            label={formatMessage({ id: 'workspaceCommon.content.dropdown.batch.label' })}
            placeholder={formatMessage({
              id: 'workspaceCommon.content.dropdown.batch.placeholder',
            })}
            disabled={isMetricsBatchTypeListLoading || batchTypeOptions.length === 0 || !projectId}
            width="medium"
            value={batchTypeId ?? ''}
          />
        </Box>
        <Box>
          {!projectId ? (
            <ProjectNotSelected />
          ) : !batchTypeId ? (
            <BatchNotSelected />
          ) : (
            <Box>
              <IRRScoreCards />
              <IRRScoreDataTable />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
